import { Component, OnInit, ViewEncapsulation } from '@angular/core'

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-quick-sidebar',
  templateUrl: './quick-sidebar.component.html'
})
export class QuickSidebarComponent implements OnInit {
  constructor () {}
  public ngOnInit () {}
}
